import { useState } from "react";
import { generateUniqueKey } from "../Helper";

/**
 * useKeyGenerator hook
 * It generates a unique key, and returns it with a function to generate a new one.
 * @returns {[number , ()=> void]} [key, generateNewKey]
 * @example
 * const [key, generateNewKey] = useKeyGenerator();
 * // key is a unique key
 * // generateNewKey is a function that returns a new unique key
 */
export const useKeyGenerator = () => {
  const [key, setKey] = useState(generateUniqueKey);
  return [key, () => setKey(generateUniqueKey)];
};
